import {atom} from 'jotai';

export const sideLengthAtom = atom(125);
